import { EVENTS_CONFIRM, EVENTS_CONFIRM_SUCCESS, EVENTS_CONFIRM_ERROR, EVENTS_CONFIRM_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const EventsConfirm = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS_CONFIRM:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EVENTS_CONFIRM_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EVENTS_CONFIRM_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EVENTS_CONFIRM_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default EventsConfirm;
